// Pure formatting / label / id helpers. No React, Firebase, or app state.

export const uid = () => Math.random().toString(36).slice(2, 10);
export const pkgId = () => `pkg_${Math.random().toString(36).slice(2, 10)}`;
export const fmt = (n, cur = "") => `${cur}${Number(n || 0).toLocaleString("en-IN")}`;

// Revenue goals: whole non-negative number, capped at 1e9 so a stray extra zero
// can't blow out the GoalBar math or the Firestore write.
export const clampGoal = (v) => Math.min(Math.max(Math.round(Number(v) || 0), 0), 1e9);

export const tzOffsetEast = () => new Date().getTimezoneOffset() * -1;

// Client phone lives in `mobile`; some legacy/mapped objects use `phone`.
export const clientPhone = (c) => (c?.mobile || c?.phone || "").replace(/\D/g, "");
// Opens WhatsApp with a prefilled message. Returns false if there's no number.
export const openWhatsApp = (phone, msg) => {
  if (!phone) return false;
  window.open(`https://wa.me/${phone}?text=${encodeURIComponent(msg)}`, "_blank");
  return true;
};

export const CURRENCY_SYMBOLS = { INR: "₹", USD: "$", EUR: "€", GBP: "£", JPY: "¥", CNY: "¥", AUD: "A$", CAD: "C$", CHF: "Fr", AED: "د.إ", SAR: "﷼", QAR: "﷼", KWD: "د.ك", OMR: "ر.ع.", SGD: "S$", HKD: "HK$", NZD: "NZ$", MYR: "RM", THB: "฿", IDR: "Rp", PHP: "₱", PKR: "₨", BDT: "৳", NPR: "₨", LKR: "₨", KRW: "₩", TRY: "₺", RUB: "₽", BRL: "R$", MXN: "$", ZAR: "R", NGN: "₦", EGP: "£", MAD: "د.م.", UAH: "₴", PLN: "zł", SEK: "kr", NOK: "kr", DKK: "kr", CZK: "Kč", HUF: "Ft", ILS: "₪", VND: "₫", TWD: "NT$" };
export const getCurrencySymbol = (profile) => {
  const c = profile?.currency;
  if (!c) return "₹";
  // Handle "INR - Indian Rupee" (old) and "₹ INR - Indian Rupee" (new symbol prefix)
  const code = c.split(" - ")[0].trim().split(" ").pop();
  return CURRENCY_SYMBOLS[code] || code;
};

// Singular / plural session label from profile.
export const sl = (profile, n = 1) => {
  const base = profile?.sessionLabel || "Session";
  if (base === "Other" && profile?.sessionLabelCustom) return n === 1 ? profile.sessionLabelCustom : profile.sessionLabelCustom + "s";
  return n === 1 ? base : base + "s";
};

// Singular / plural client label from profile. A custom label (clientLabel
// "Other" + a typed-in name) wins regardless of n — checked before the n===1
// shortcut, or the singular form would ignore it and show the literal "Other".
export const cl = (profile, n = 1) => {
  const base = profile?.clientLabel || "Client";
  if (profile?.clientLabelCustom) return n === 1 ? profile.clientLabelCustom : profile.clientLabelCustom + "s";
  if (n === 1) return base;
  if (base === "Other") return base + "s";
  const irregulars = { Patient: "Patients", Trainee: "Trainees", Mentee: "Mentees" };
  return irregulars[base] || base + "s";
};

export const sortOtherLast = (arr) => [...arr.filter((x) => x !== "Other").sort(), (arr.includes("Other") ? "Other" : null)].filter(Boolean);

export const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

// 06:00 → 19:30, half-hour steps, "hh:mm AM/PM".
export const TIMES = Array.from({ length: 28 }, (_, i) => {
  const h = Math.floor(i / 2) + 6, m = i % 2 === 0 ? "00" : "30", hh = h > 12 ? h - 12 : h, ap = h >= 12 ? "PM" : "AM";
  return `${String(hh).padStart(2, "0")}:${m} ${ap}`;
});
